// extracted by mini-css-extract-plugin
export default {"root":"AppointmentStatus_root__9Rc9O","cancelled":"AppointmentStatus_cancelled__FpwzQ"};